(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-background/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-background/assets/javascripts/prescript.js');
svs.banner_groups = svs.banner_groups || {};
svs.banner_groups.banner_background = svs.banner_groups.banner_background || {};


 })(window);